module.exports = __webpack_public_path__ + "static/img/p-19.f65bce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-19.png
// module id = B0Uv
// module chunks = 0